if (!customElements.get('kk-category-scroll')) {
  customElements.define('kk-category-scroll', class extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('nav');
      this.buttons = [...this.querySelectorAll('button[data-direction]')];
      if (!this.nav || this.buttons.length !== 2) return;

      this.lifecycle = new AbortController();
      const options = { signal: this.lifecycle.signal };
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.isRtl = getComputedStyle(this.nav).direction === 'rtl';
      this.setAttribute('data-enhanced', '');

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.scrollByDirection(Number(button.dataset.direction));
        }, options);
      });

      this.nav.addEventListener('keydown', (event) => this.handleKeydown(event), options);
      this.scheduleUpdate = () => {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = 0;
          this.update();
        });
      };

      this.update = () => {
        const items = [...this.nav.children];
        const hasOverflow = this.nav.scrollWidth > this.nav.clientWidth + 2;

        if (!hasOverflow || items.length === 0) {
          this.toggleAttribute('data-overflow', false);
          this.buttons.forEach((button) => {
            button.hidden = true;
            button.disabled = true;
          });
          return;
        }

        const navRect = this.nav.getBoundingClientRect();
        const firstRect = items[0].getBoundingClientRect();
        const lastRect = items[items.length - 1].getBoundingClientRect();
        const atStart = this.isRtl
          ? firstRect.right <= navRect.right + 2
          : firstRect.left >= navRect.left - 2;
        const atEnd = this.isRtl
          ? lastRect.left >= navRect.left - 2
          : lastRect.right <= navRect.right + 2;

        this.toggleAttribute('data-overflow', true);
        this.buttons.forEach((button) => { button.hidden = false; });
        if (this.buttons[0].disabled !== atStart) this.buttons[0].disabled = atStart;
        if (this.buttons[1].disabled !== atEnd) this.buttons[1].disabled = atEnd;
      };

      this.nav.addEventListener('scroll', this.scheduleUpdate, { ...options, passive: true });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.scheduleUpdate);
        this.observer.observe(this.nav);
      }
      document.fonts?.ready.then(this.scheduleUpdate);
      this.scheduleUpdate();
    }

    scrollByDirection(direction, behavior = this.reducedMotion.matches ? 'auto' : 'smooth') {
      const distance = Math.max(180, this.nav.clientWidth * .72);
      this.nav.scrollBy({
        left: (this.isRtl ? -direction : direction) * distance,
        behavior
      });
    }

    handleKeydown(event) {
      if (event.target !== this.nav) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        const physicalDirection = event.key === 'ArrowLeft' ? -1 : 1;
        this.nav.scrollBy({
          left: physicalDirection * Math.max(120, this.nav.clientWidth * .45),
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
        });
      }
      if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        const limit = this.nav.scrollWidth - this.nav.clientWidth;
        const isEnd = event.key === 'End';
        this.nav.scrollTo({
          left: isEnd ? (this.isRtl ? -limit : limit) : 0,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
        });
      }
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
      this.observer?.disconnect();
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
    }
  });
}
